import { render, staticRenderFns } from "./ReviewItemTable.vue?vue&type=template&id=22521c04&scoped=true"
import script from "./ReviewItemTable.vue?vue&type=script&lang=ts"
export * from "./ReviewItemTable.vue?vue&type=script&lang=ts"
import style0 from "./ReviewItemTable.vue?vue&type=style&index=0&id=22521c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22521c04",
  null
  
)

export default component.exports